import React from 'react';

// The mark's strokes are one grey. `color` lets a caller invert them for a
// coloured background — on the primary button the grey all but disappears —
// without every other caller having to name the grey it already had.
const NEXUS_MARK_COLOR = '#475467';

function NexusLogo({ size = 32, color = NEXUS_MARK_COLOR }: { size?: number; color?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height={size}
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      // Inline by default, so the line box around it lifts the mark off the
      // centre of anything it is centred in — two pixels inside the round
      // Nexus button, whose line height is taller than the mark.
      style={{ display: 'block' }}
    >
      <defs>
        <clipPath id="274aceff31">
          <path
            d="M 49.125 51.699219 L 133.875 51.699219 L 133.875 136.449219 L 49.125 136.449219 Z M 49.125 51.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="a39bb6de90">
          <path
            d="M 91.5 51.699219 C 68.097656 51.699219 49.125 70.671875 49.125 94.074219 C 49.125 117.476562 68.097656 136.449219 91.5 136.449219 C 114.902344 136.449219 133.875 117.476562 133.875 94.074219 C 133.875 70.671875 114.902344 51.699219 91.5 51.699219 Z M 91.5 51.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="893f7a262a">
          <path
            d="M 0.125 0.699219 L 84.875 0.699219 L 84.875 85.449219 L 0.125 85.449219 Z M 0.125 0.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="de68a13f74">
          <path
            d="M 42.5 0.699219 C 19.097656 0.699219 0.125 19.671875 0.125 43.074219 C 0.125 66.476562 19.097656 85.449219 42.5 85.449219 C 65.902344 85.449219 84.875 66.476562 84.875 43.074219 C 84.875 19.671875 65.902344 0.699219 42.5 0.699219 Z M 42.5 0.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="ca96f31730">
          <rect x="0" width="85" y="0" height="86" />
        </clipPath>
        <clipPath id="880bd673f8">
          <path
            d="M 49.125 238.550781 L 133.875 238.550781 L 133.875 323.300781 L 49.125 323.300781 Z M 49.125 238.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="3911005fcc">
          <path
            d="M 91.5 238.550781 C 68.097656 238.550781 49.125 257.523438 49.125 280.925781 C 49.125 304.328125 68.097656 323.300781 91.5 323.300781 C 114.902344 323.300781 133.875 304.328125 133.875 280.925781 C 133.875 257.523438 114.902344 238.550781 91.5 238.550781 Z M 91.5 238.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="44600f3702">
          <path
            d="M 0.125 0.550781 L 84.875 0.550781 L 84.875 85.300781 L 0.125 85.300781 Z M 0.125 0.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="2f91fabc66">
          <path
            d="M 42.5 0.550781 C 19.097656 0.550781 0.125 19.523438 0.125 42.925781 C 0.125 66.328125 19.097656 85.300781 42.5 85.300781 C 65.902344 85.300781 84.875 66.328125 84.875 42.925781 C 84.875 19.523438 65.902344 0.550781 42.5 0.550781 Z M 42.5 0.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="9fd8c21181">
          <rect x="0" width="85" y="0" height="86" />
        </clipPath>
        <clipPath id="eac22d6570">
          <path
            d="M 241.125 238.550781 L 325.875 238.550781 L 325.875 323.300781 L 241.125 323.300781 Z M 241.125 238.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="51fe9fe1a4">
          <path
            d="M 283.5 238.550781 C 260.097656 238.550781 241.125 257.523438 241.125 280.925781 C 241.125 304.328125 260.097656 323.300781 283.5 323.300781 C 306.902344 323.300781 325.875 304.328125 325.875 280.925781 C 325.875 257.523438 306.902344 238.550781 283.5 238.550781 Z M 283.5 238.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="19c9c8df7f">
          <path
            d="M 0.125 0.550781 L 84.875 0.550781 L 84.875 85.300781 L 0.125 85.300781 Z M 0.125 0.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="b362999955">
          <path
            d="M 42.5 0.550781 C 19.097656 0.550781 0.125 19.523438 0.125 42.925781 C 0.125 66.328125 19.097656 85.300781 42.5 85.300781 C 65.902344 85.300781 84.875 66.328125 84.875 42.925781 C 84.875 19.523438 65.902344 0.550781 42.5 0.550781 Z M 42.5 0.550781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="f97e43a355">
          <rect x="0" width="85" y="0" height="86" />
        </clipPath>
        <clipPath id="9318f58867">
          <path
            d="M 241.125 51.699219 L 325.875 51.699219 L 325.875 136.449219 L 241.125 136.449219 Z M 241.125 51.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="66eca62f1c">
          <path
            d="M 283.5 51.699219 C 260.097656 51.699219 241.125 70.671875 241.125 94.074219 C 241.125 117.476562 260.097656 136.449219 283.5 136.449219 C 306.902344 136.449219 325.875 117.476562 325.875 94.074219 C 325.875 70.671875 306.902344 51.699219 283.5 51.699219 Z M 283.5 51.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="e64f8cf6aa">
          <path
            d="M 0.125 0.699219 L 84.875 0.699219 L 84.875 85.449219 L 0.125 85.449219 Z M 0.125 0.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="0e13633ff1">
          <path
            d="M 42.5 0.699219 C 19.097656 0.699219 0.125 19.671875 0.125 43.074219 C 0.125 66.476562 19.097656 85.449219 42.5 85.449219 C 65.902344 85.449219 84.875 66.476562 84.875 43.074219 C 84.875 19.671875 65.902344 0.699219 42.5 0.699219 Z M 42.5 0.699219 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="816619d850">
          <rect x="0" width="85" y="0" height="86" />
        </clipPath>
        <clipPath id="7a7c5ae95a">
          <path
            d="M 148.5 145.925781 L 233.25 145.925781 L 233.25 230.675781 L 148.5 230.675781 Z M 148.5 145.925781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="f66cd9a5d5">
          <path
            d="M 190.875 145.925781 C 167.472656 145.925781 148.5 164.898438 148.5 188.300781 C 148.5 211.703125 167.472656 230.675781 190.875 230.675781 C 214.277344 230.675781 233.25 211.703125 233.25 188.300781 C 233.25 164.898438 214.277344 145.925781 190.875 145.925781 Z M 190.875 145.925781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="5f1e95d86b">
          <path
            d="M 0.5 0.925781 L 85.25 0.925781 L 85.25 85.675781 L 0.5 85.675781 Z M 0.5 0.925781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="383ba653dd">
          <path
            d="M 42.875 0.925781 C 19.472656 0.925781 0.5 19.898438 0.5 43.300781 C 0.5 66.703125 19.472656 85.675781 42.875 85.675781 C 66.277344 85.675781 85.25 66.703125 85.25 43.300781 C 85.25 19.898438 66.277344 0.925781 42.875 0.925781 Z M 42.875 0.925781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="df816786cf">
          <rect x="0" width="86" y="0" height="86" />
        </clipPath>
        <clipPath id="e1ccce5fec">
          <path d="M 192 90 L 291 90 L 291 189 L 192 189 Z M 192 90 " clipRule="nonzero" />
        </clipPath>
        <clipPath id="0ac8f6dbee">
          <path
            d="M 192.070312 169.738281 L 271.617188 90.1875 L 290.179688 108.75 L 210.632812 188.300781 Z M 192.070312 169.738281 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="05743e257d">
          <path d="M 0 0 L 98.398438 0 L 98.398438 98.398438 L 0 98.398438 Z M 0 0 " clipRule="nonzero" />
        </clipPath>
        <clipPath id="af94ffff55">
          <path
            d="M 0.0703125 79.738281 L 79.617188 0.1875 L 98.179688 18.75 L 18.632812 98.300781 Z M 0.0703125 79.738281 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="609349b351">
          <rect x="0" width="99" y="0" height="99" />
        </clipPath>
        <clipPath id="3ceeec394a">
          <path d="M 188 180 L 284 180 L 284 282 L 188 282 Z M 188 180 " clipRule="nonzero" />
        </clipPath>
        <clipPath id="9f6242dbe4">
          <path
            d="M 207.867188 180.800781 L 283.5 264.082031 L 264.066406 281.730469 L 188.433594 198.449219 Z M 207.867188 180.800781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="1a11c54c4c">
          <path
            d="M 0.398438 0.71875 L 95.679688 0.71875 L 95.679688 101.761719 L 0.398438 101.761719 Z M 0.398438 0.71875 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="ce9935d5fb">
          <path
            d="M 19.867188 0.800781 L 95.5 84.082031 L 76.066406 101.730469 L 0.433594 18.449219 Z M 19.867188 0.800781 "
            clipRule="nonzero"
          />
        </clipPath>
        <clipPath id="951f63e553">
          <rect x="0" width="96" y="0" height="102" />
        </clipPath>
      </defs>
      <g clipPath="url(#274aceff31)">
        <g clipPath="url(#a39bb6de90)">
          <g transform="matrix(1, 0, 0, 1, 49, 51)">
            <g clipPath="url(#ca96f31730)">
              <g clipPath="url(#893f7a262a)">
                <g clipPath="url(#de68a13f74)">
                  <path
                    fill={color}
                    d="M 0.125 0.699219 L 84.875 0.699219 L 84.875 85.449219 L 0.125 85.449219 Z M 0.125 0.699219 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#880bd673f8)">
        <g clipPath="url(#3911005fcc)">
          <g transform="matrix(1, 0, 0, 1, 49, 238)">
            <g clipPath="url(#9fd8c21181)">
              <g clipPath="url(#44600f3702)">
                <g clipPath="url(#2f91fabc66)">
                  <path
                    fill={color}
                    d="M 0.125 0.550781 L 84.875 0.550781 L 84.875 85.300781 L 0.125 85.300781 Z M 0.125 0.550781 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#eac22d6570)">
        <g clipPath="url(#51fe9fe1a4)">
          <g transform="matrix(1, 0, 0, 1, 241, 238)">
            <g clipPath="url(#f97e43a355)">
              <g clipPath="url(#19c9c8df7f)">
                <g clipPath="url(#b362999955)">
                  <path
                    fill={color}
                    d="M 0.125 0.550781 L 84.875 0.550781 L 84.875 85.300781 L 0.125 85.300781 Z M 0.125 0.550781 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#9318f58867)">
        <g clipPath="url(#66eca62f1c)">
          <g transform="matrix(1, 0, 0, 1, 241, 51)">
            <g clipPath="url(#816619d850)">
              <g clipPath="url(#e64f8cf6aa)">
                <g clipPath="url(#0e13633ff1)">
                  <path
                    fill={color}
                    d="M 0.125 0.699219 L 84.875 0.699219 L 84.875 85.449219 L 0.125 85.449219 Z M 0.125 0.699219 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#7a7c5ae95a)">
        <g clipPath="url(#f66cd9a5d5)">
          <g transform="matrix(1, 0, 0, 1, 148, 145)">
            <g clipPath="url(#df816786cf)">
              <g clipPath="url(#5f1e95d86b)">
                <g clipPath="url(#383ba653dd)">
                  <path
                    fill={color}
                    d="M 0.5 0.925781 L 85.25 0.925781 L 85.25 85.675781 L 0.5 85.675781 Z M 0.5 0.925781 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#e1ccce5fec)">
        <g clipPath="url(#0ac8f6dbee)">
          <g transform="matrix(1, 0, 0, 1, 192, 90)">
            <g clipPath="url(#609349b351)">
              <g clipPath="url(#05743e257d)">
                <g clipPath="url(#af94ffff55)">
                  <path
                    fill={color}
                    d="M 0.0703125 79.738281 L 79.609375 0.199219 L 98.171875 18.761719 L 18.632812 98.300781 Z M 0.0703125 79.738281 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g clipPath="url(#3ceeec394a)">
        <g clipPath="url(#9f6242dbe4)">
          <g transform="matrix(1, 0, 0, 1, 188, 180)">
            <g clipPath="url(#951f63e553)">
              <g clipPath="url(#1a11c54c4c)">
                <g clipPath="url(#ce9935d5fb)">
                  <path
                    fill={color}
                    d="M 19.867188 0.800781 L 95.488281 84.070312 L 76.058594 101.71875 L 0.433594 18.449219 Z M 19.867188 0.800781 "
                    fillOpacity="1"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default NexusLogo;
